"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventStatuses = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
exports.eventStatuses = [
    betweb_openapi_axios_1.ActiveEventStatus.Suspended,
    betweb_openapi_axios_1.ActiveEventStatus.Trading,
    betweb_openapi_axios_1.ActiveEventStatus.Planning,
    betweb_openapi_axios_1.ActiveEventStatus.Open,
].map((el) => el.replace('EVENT_', ''));
//# sourceMappingURL=constants.js.map